/*!
 * Copyright 2022 Thorne Health Lab. All rights reserved.
 */
import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import Phone from '../containers/Phone';
import Passcode from '../containers/Passcode';
import Signup from '../containers/Signup/index';
import Activation from '../containers/Activation';
import Visits from '../containers/Visits';
import Visit from '../containers/Visit';
import Schedule from '../containers/Schedule';
import Payment from '../containers/Payment';
import Profile from '../containers/Profile';
import UpcomingVisit from '../containers/UpcomingVisit';
import Terms from '../containers/Terms';
import Assessments from '../containers/Assessments';
import Assessment from '../containers/Assessment';
import Reports from '../containers/Reports';
import Report from '../containers/Report';
import Logout from '../containers/Logout';
import PatientLanding from '../containers/PatientLanding';
import PreRegistration from '../containers/PreReg';
import App from '../containers/App/app';
import PrivateRoute from './privateRoute';
import ScheduleAppointment from '../containers/ScheduleAppointment';
import ViewAppointment from '../containers/ViewAppointment';
import PastVisits from '../containers/PastVisits';
import Spinner from '../components/Spinner';
import { useSelector } from 'react-redux';
import Element from '../components/element';
import { colors } from '../config/theme';
import GlobalMessage from '../components/GlobalMessage';
import VisitDetails from '../containers/PastVisits/VisitDetails';
import PreAssessments from '../containers/PastVisits/PreAssessments';
import HealthReport from '../containers/PastVisits/HealthReport';
import Ratings from '../containers/Ratings';
import PrivacyPolicy from '../containers/PrivacyPolicy';
import ContactUs from '../containers/ContactUs'

export const appRoutes = (
  <BrowserRouter>
    <Routes>
      {/* <Redirect from="/" to="/upcoming" /> */}
      <Route path="/upcoming/schedule" element={Schedule} />

      <Route path="/upcoming/terms" element={Terms} />
      <Route path="/upcoming/payment" element={Payment} />

      <Route path="/upcoming" element={UpcomingVisit} />
      <Route
        path="/visits/:visitId/assessments/:assessmentId/:assessmentPage"
        element={Assessment}
      />
      <Route
        path="/visits/:visitId/assessments/:assessmentId"
        element={Assessment}
      />
      <Route path="/visits/:id/assessments" element={Assessments} />
      <Route path="/visits/:visitId/reports/:reportId" element={Report} />
      <Route path="/visits/:id/reports" element={Reports} />
      <Route path="/visits/:id" element={Visit} />
      <Route path="/visits" element={Visits} />
      <Route path="/profile" element={Profile} />
      <Route path="/logout" element={Logout} />
      {/* <Redirect to="/" /> */}
    </Routes>
  </BrowserRouter>
);
export const AuthRoutes = () => {
  const loading = useSelector(state => state.api.get('isLoading'));
  const appHasError = useSelector(state => {
    return state.api.get('hasError');
  });
  const appErrorMsg = useSelector(state => {
    return state.api.get('error');
  });
  return (
    <Element backgroundColor={colors.lighterGray} padding="30px">
      <BrowserRouter>
        {loading && <Spinner />}
        {appHasError ? (
          <GlobalMessage isWarning>{appErrorMsg}</GlobalMessage>
        ) : null}
        <Routes>
          <Route path="/" element={<App />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/contactus" element={<ContactUs />} />
          <Route path="/passcode" element={<Passcode />} />
          <Route path="/(phone|login)/" element={<Phone />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/questionarie" element={<PreRegistration />} />
          <Route path="/activation" element={Activation} />
          <Route path="/feedback" element={<Ratings />} />
          <Route element={<PrivateRoute />}>
            <Route path="landing" element={<PatientLanding />}>
              <Route path="assessments" element={<Assessments />}>
                <Route path=":assessmentId" element={<Assessment />} />
              </Route>
              <Route
                path="appointment/schedule"
                element={<ScheduleAppointment />}
              />
              <Route path="appointment/view" element={<ViewAppointment />} />
              <Route path="pastvisits" element={<PastVisits />} />
              <Route
                path="pastvisits/individualVisit"
                element={<VisitDetails />}
              />
              <Route
                path="pastvisits/preAssessments"
                element={<PreAssessments />}
              />
              <Route
                path="pastvisits/healthReport"
                element={<HealthReport />}
              />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </Element>
  );
};
